import React, { useEffect } from 'react';
import { Button, Switch, Drawer, Form, Input, message } from 'antd';
import { AppVersionService } from 'services/AppVersionService';
import {
  CREATE_ERROR,
  EDIT_ERROR,
  REQUEST_LOADING,
  SUCCESS_CREATE,
  SUCCESS_UPDATE,
} from 'constants/alerts';
import { requiredRule } from 'utils/forms/validationRules';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';

function AppVersionForm({ isActive, onClose, onSuccess, initialValues }) {
  const [form] = Form.useForm();
  const isEditing = initialValues !== null;

  useEffect(() => {
    if (initialValues) {
      const {
        version,
        message,
        message_kz,
        change_log,
        change_log_kz,
        canEscape,
      } = initialValues;

      form.setFieldsValue({
        version,
        message,
        message_kz,
        change_log,
        change_log_kz,
        canEscape,
      });
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleSubmit = (values) => {
    if (isEditing) {
      handleUpdate(values, initialValues.id);
    } else {
      handleCreate(values);
    }
  };

  const handleCreate = async (data) => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isCreated = await AppVersionService.createAppVersion(data);

      if (isCreated) {
        handleConfirm();
        message.success(SUCCESS_CREATE);
      }
    } catch (err) {
      message.error(CREATE_ERROR);
    } finally {
      hide();
    }
  };

  const handleUpdate = async (data, id) => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isUpdated = await AppVersionService.updateAppVersion(id, data);

      if (isUpdated) {
        handleConfirm();
        message.success(SUCCESS_UPDATE);
      }
    } catch (err) {
      message.error(EDIT_ERROR);
    } finally {
      hide();
    }
  };

  const handleConfirm = () => {
    form.resetFields();
    onClose();
    onSuccess();
  };

  return (
    <Drawer
      title={
        isEditing
          ? 'Редактирование версии приложения'
          : 'Создание версии приложения'
      }
      width="50%"
      onClose={onClose}
      visible={isActive}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        labelAlign="right"
        initialValues={{ canEscape: true }}
      >
        <Form.Item name="version" label="Версия" rules={[requiredRule]}>
          <Input placeholder="App version" allowClear />
        </Form.Item>

        <Form.Item name="message" label="Заголовок">
          <Input placeholder="Введите заголовок" allowClear />
        </Form.Item>

        <Form.Item name="message_kz" label="Заголовок (кз)">
          <Input placeholder="Введите заголовок на казахском" allowClear />
        </Form.Item>

        <Form.Item name="change_log" label="Описание">
          <Input.TextArea placeholder="Введите описание" allowClear />
        </Form.Item>

        <Form.Item name="change_log_kz" label="Описание (кз)">
          <Input.TextArea
            placeholder="Введите описание на казахском"
            allowClear
          />
        </Form.Item>

        <Form.Item
          name="canEscape"
          label="SOFT обновление"
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit">
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { AppVersionForm };
